import React, { useRef, useEffect, useState } from 'react';

const VideoLoopBackground = () => {
  const video1Ref = useRef(null);
  const video2Ref = useRef(null);
  const [currentVideo, setCurrentVideo] = useState(1);
  const isUnmountedRef = useRef(false);

  useEffect(() => {
    const video1 = video1Ref.current;
    const video2 = video2Ref.current;

    if (!video1 || !video2) return;

    const playVideo = async (video) => {
      if (isUnmountedRef.current) return;
      try {
        await video.play();
      } catch (error) {
        // Silently handle play errors (autoplay restrictions, etc.)
        if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') {
          console.warn('Video play error:', error);
        }
      }
    };

    const handleVideo1End = () => {
      if (isUnmountedRef.current) return;
      video1.style.opacity = '0';
      video2.style.opacity = '1';
      video2.currentTime = 0;
      playVideo(video2);
      setCurrentVideo(2);
    };

    const handleVideo2End = () => {
      if (isUnmountedRef.current) return;
      video2.style.opacity = '0';
      video1.style.opacity = '1';
      video1.currentTime = 0;
      playVideo(video1);
      setCurrentVideo(1);
    };

    video1.addEventListener('ended', handleVideo1End);
    video2.addEventListener('ended', handleVideo2End);

    // Start with video 1 after a small delay to ensure it's loaded
    const startTimeout = setTimeout(() => {
      playVideo(video1);
    }, 100);

    return () => {
      isUnmountedRef.current = true;
      clearTimeout(startTimeout);
      video1.removeEventListener('ended', handleVideo1End);
      video2.removeEventListener('ended', handleVideo2End);
      // Pause videos to prevent play errors on unmount
      video1.pause();
      video2.pause();
    };
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden">
      <video
        ref={video1Ref}
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
        style={{ opacity: 1 }}
      >
        <source
          src="https://customer-assets.emergentagent.com/job_opale-lavage/artifacts/1uheg00j_f5e3b5e8-6cef-4512-aac6-803eba3a3d5d.mp4"
          type="video/mp4"
        />
      </video>
      <video
        ref={video2Ref}
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
        style={{ opacity: 0 }}
      >
        <source
          src="https://customer-assets.emergentagent.com/job_opale-lavage/artifacts/jsxjm7ss_96c17772-8295-4535-a7ad-e386292fd3a6.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  );
};

export default VideoLoopBackground;
